import store from '@/store'
import { createMiddleware } from 'vue-router-middleware' 

createMiddleware('auth-required', (args, to, from, next) => {

    if (store.get('auth/is_logged_in')) {
        return next();
    }

    return next({ name: 'login' })
})